import $ from 'jquery';

$(() => {
    const scrollToHash = (hash, behavior = 'smooth') => {
        const target = document.getElementById(hash.replace('#', ''));

        if (!target) {
            return;
        }

        const header = $('.header');
        const headerPosition = header.css('position');
        const headerHeight = headerPosition === 'fixed' || headerPosition === 'sticky' ? header.outerHeight() : 0;
        const scrollTop = $(target).offset().top - headerHeight - 50;

        $('html, body').stop().animate({ scrollTop }, behavior === 'smooth' ? 400 : 0);
    };

    $(document).on('click', '.portrait-page-override a[href*="#"]', function onPortraitNavigationClick(event) {
        const link = this;
        const isCurrentPage = link.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');

        if (!isCurrentPage || !document.getElementById(link.hash.replace('#', ''))) {
            return;
        }

        event.preventDefault();
        window.history.pushState(null, '', link.hash);

        const menuIsOpen = $('body').hasClass('nav-open');

        if (menuIsOpen) {
            $('.js-nav-toggle').trigger('click');
        }

        setTimeout(() => scrollToHash(link.hash), menuIsOpen ? 400 : 0);
    });

    $(window).on('hashchange', () => scrollToHash(window.location.hash));

    if (window.location.hash) {
        setTimeout(() => scrollToHash(window.location.hash, 'auto'));
        $(window).on('load', () => setTimeout(() => scrollToHash(window.location.hash, 'auto')));
    }
});
